<template>
  <main class="page-container page-category main">
    
    <!-- PC Template -->
    <div>
      <div class="page-content">
        <div class="category-wrap">
          <div class="categorized-products" v-if="searchFlag">
            <!-- 온라인 상품전 참여 쇼핑몰 시작 -->
            <!-- <div class="gray-bg" v-if="isShowBtn">
              <div class="in-container">
                <div class="inFlexBox">
                  <h2>소상공인<br> 온라인 기획전</h2>
                  <div class="shop-list-wrap" @wheel.prevent="handleWheelScroll">
                    <ul class="shop-list">
                      <li v-for="item in mutualDisEventListPC" :key="item.name" class="shop-list-li">
                        <a :href="item.link" target="_blank" rel="noopener noreferrer" class="shop-list-item" @click="handleMutualEventClick($event,item.beforeEvent,item.link)" draggable="false">
                          <div class="shop-list-item-img">
                            <i class="icon">
                              <img :src="require('@/assets/img/mutual/' + item.img)" alt="" draggable="false">
                            </i>
                          </div>
                          <span v-html="item.name"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- 온라인 상품전 참여 쇼핑몰 끝 -->

            <div class="srchBoxWrap borderB">
      <div class="container">
        <h5 class="moOnly" style="font-size: 20px; text-align: center; color: #000; padding-bottom: 5px;">2026년 4월</h5>
        <h2><span class="mbNone">2026년 4월</span> 동행제품 300선</h2>
        <div class="inFlexBox">
          <!-- 검색 영역 시작 -->
          <div class="srchAreaWrap">
            <span>원하시는 상품/브랜드가 있으신가요?</span>
            <div class="srchArea">
              <input type="text" title="검색어" v-model="searchName" placeholder="어떤 상품/브랜드를 찾고 있나요?" @keyup.enter="applyFiltersAndFetchAll()" style="padding-left: 14px;"/>
              <button type="button" @click="applyFiltersAndFetchAll()">검색</button>
            </div>
          </div>
        </div>
        <br/>
          <!-- <div v-if="isShowDiscountText" style="margin-top: 10px; text-align: center">
          <span style="font-size: 16px; color: #c0c0c0">4월 11일부터 할인된 가격으로 만나 보실 수 있습니다.</span>
          </div> -->

          <!-- 검색 영역 끝 -->
          <!-- 해시 태그 영역 시작 -->
          <!-- <div class="hashTagArea">
            <ul>
              <li><a href="" @click.prevent="searchHashtag('산지직송')">#산지직송</a></li>
              <li><a href="" class="bgRed" @click.prevent="searchHashtag('고추장')">#고추장</a></li>
              <li><a href="" class="bgOrng" @click.prevent="searchHashtag('생활용품')">#생활용품</a></li>
              <li><a href="" class="bgDgreen" @click.prevent="searchHashtag('가전제품')">#가전제품</a></li>
              <li><a href="" class="bgBlue" @click.prevent="searchHashtag('밀키트')">#밀키트</a></li>
              <li><a href="" class="bgOrng" @click.prevent="searchHashtag('로컬푸드')">#로컬푸드</a></li>
              <li><a href="" class="bgBlue" @click.prevent="searchHashtag('선물세트')">#선물세트</a></li>
              <li><a href="" class="bgDgreen" @click.prevent="searchHashtag('버섯')">#버섯</a></li>
              <li><a href="" class="bgRed" @click.prevent="searchHashtag('국내산')">#국내산</a></li>
              <li><a href="" @click.prevent="searchHashtag('꿀고구마')">#꿀고구마</a></li>
              <li><a href="" class="bgDgreen" @click.prevent="searchHashtag('한우')">#한우</a></li>
            </ul>
          </div> -->
          <!-- 해시 태그 영역 끝 -->
        </div>
      </div>
    </div>
            <!-- 식품관 시작 -->
            <!-- <div class="borderB mbBorderNone"> -->
            <div class="container">
                <!-- Food -->
                <div class="category-section" v-if="foodList.length > 0"><!-- 2026-03-12 rtBannerBox 클래스 삭제 -->
                  <div class="products-list">
                    <div class="category-title-box03">
                      <router-link :to="{ name: 'ProductsCategory', query: { ctgrDcd: '1501003' } }">
                    <img src="../../assets/img/main/category-title03.png" alt="">
                  </router-link>
                    </div>
                    <products-item
                      v-for="item in foodList"
                      :key="item.id"
                      :id="item.id"
                      :item="item"
                      type=""
                      :evnt-strt-dt="evntStrtDt"
                      :evnt-end-dt="evntEndDt"
                      parent-like-evnt-nm="likeClicked"
                      @likeClicked="handleClickLike"
                      parent-click-evnt-nm="modalClicked"
                      @modalClicked="handleClickModal"
                    />
                  </div>
                  <!-- <div class="rtBanner">
                    <a href="">
                      <img src="../../assets/img/main/right-banner01.png" alt="">
                    </a>
                  </div> -->
                  <div class="btn-more-cont-wrap">
                    <button type="button" class="btn-more-cont" @click="$router.push({ name: 'ProductsCategory', query: { ctgrDcd: '1501003' } })"><span>상품 더보기</span></button>
                  </div>
                </div>
            </div>
            <!-- </div> -->
            <!-- 식품관 끝 -->
             
            <!-- 뷰티 & 패션관 시작 -->
            <div class="container">
              <div class="category-section" v-if="beautyList.length > 0">
                <div class="products-list">
                  <div class="category-title-box01">
                    <router-link :to="{ name: 'ProductsCategory', query: { ctgrDcd: '1501001' } }">
                      <img src="../../assets/img/main/category-title01.png" alt="">
                    </router-link>
                  </div>
                  <products-item
                    v-for="item in beautyList"
                    :key="item.id"
                    :id="item.id"
                    :item="item"
                    type=""
                    :evnt-strt-dt="evntStrtDt"
                    :evnt-end-dt="evntEndDt"
                    parent-like-evnt-nm="likeClicked"
                    @likeClicked="handleClickLike"
                    parent-click-evnt-nm="modalClicked"
                    @modalClicked="handleClickModal"
                  />
                </div>
                <div class="btn-more-cont-wrap">
                  <button type="button" class="btn-more-cont" @click="$router.push({ name: 'ProductsCategory', query: { ctgrDcd: '1501001' } })"><span>상품 더보기</span></button>
                </div>
              </div>
            </div>
            <!-- 뷰티 & 패션관 끝 -->

            <!-- 생활상품관 시작-->
            <div class="container">
              <div class="category-section" v-if="livingList.length > 0">
                <div class="products-list">
                  <div class="category-title-box02">
                    <router-link :to="{ name: 'ProductsCategory', query: { ctgrDcd: '1501008' } }">
                      <img src="../../assets/img/main/category-title02-PC.png" alt="">
                    </router-link>
                  </div>
                  <products-item
                    v-for="item in livingList"
                    :key="item.id"
                    :id="item.id"
                    :item="item"
                    type=""
                    :evnt-strt-dt="evntStrtDt"
                    :evnt-end-dt="evntEndDt"
                    parent-like-evnt-nm="likeClicked"
                    @likeClicked="handleClickLike"
                    parent-click-evnt-nm="modalClicked"
                    @modalClicked="handleClickModal"
                  />
                </div>
                <div class="btn-more-cont-wrap">
                  <button type="button" class="btn-more-cont" @click="$router.push({ name: 'ProductsCategory', query: { ctgrDcd: '1501008' } })"><span>상품 더보기</span></button>
                </div>
              </div>
            </div>
            <!-- 생활상품관 끝 -->

            <!-- 2026년 3월 동행축제 온라인 이벤트 시작 -->
            <!-- <div class="container">
              <div class="event-banner-wrap">
                <a href="">
                  <img src="../../assets/img/main/event-banner01.png" alt="">
                </a>
              </div>
            </div> -->
            <!-- 2026년 3월 동행축제 온라인 이벤트 끝 -->

          </div>

          <div class="products-list" v-if="!searchFlag">
            <div class="no-data-message" style ="font-size: 26px;" >상품을 찾을 수 없습니다.</div>
          </div>
        </div>

        <!-- 동행축제 Hot5 상품 시작 -->
        <!-- <div class="best-item-wrap">
          <div class="container">
            <div class="in-box">
              <h2>소비자가 선택한 <b>동행축제 Hot5 상품</b></h2>
              <p>
                소상공인과 함께 하는 동행축제 2025에 방문해주신 소비자께서 좋아요 클릭에 따른 인기상품입니다.<br>
                <b>동행축제 상품에 대한 관심을 좋아요로 표현해주세요!</b>
              </p>
              <swiper :options="bestItemOption" class="swiper-container best-item-swiper">
                <swiper-slide v-for="(item, i) in mostLikedProducts" :key="item.id">
                  <div class="img-wrap">
                      <a href="javascript:;" @click="handleClickModal(item.id)">
                        <span>{{ i + 1 }}위</span>
                        <img :src="item.image" :alt="item.title">
                      </a>
                      <div class="btn-wrap">
                        <button type="button" class="btn-share" @click="handleClickShareHot5(item)">공유하기</button>
                        <button type="button" class="btn-like on" :class="{ on: item.like }" @click="increaseLikeCountHot5(item)">좋아요</button>
                      </div>
                    </div>
                    <div class="txt-wrap">
                      <a href="javascript:;" @click="handleClickModal(item.id)">
                        <span class="best-item-company">{{ item.company }}</span>
                        <span class="best-item-title">{{ item.title }}</span>
                        <span class="best-item-price">{{ Number(item.price).toLocaleString() }}</span>
                      </a>
                    </div>
                    <div class="total-wrap">
                      <span class="like-total">좋아요 {{ Number(item.likeCount).toLocaleString() }}회</span>
                      <span class="share-total">공유 {{ Number(item.shareCount || 0).toLocaleString() }}회</span>
                    </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div> -->
        <!-- 동행축제 Hot5 상품 끝 -->

        <!-- 동행축제 영상보기 시작-->
        <!-- <div class="promo-section">
          <div class="container">
            <div class="inFlexBox">
              <div class="promo-card video-card">
                <h2>동행축제 <b>영상보기</b></h2>
                <div class="in-cont">
                  <iframe
                    :src="videoUrl"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen=""
                  >
                  </iframe>
                </div>
                <a href="">더보기</a>
              </div>
              <div class="promo-card event-banner">
                <h2>전통시장·골목시장 <b>소비이벤트</b></h2>
                <div class="in-cont">
                  <a href="">
                    <img src="../../assets/img/main/img-promo02.png" class="m1024None" alt="">
                    <img src="../../assets/img/main/img-promo02-m.png" class="m1024Block" alt="">
                  </a>
                </div>
                <a href="">더보기</a>
              </div>
            </div>
          </div>
        </div> -->
        <!-- 동행축제 영상보기 끝-->
      </div>
    </div>
   
    <!--// PC Template -->

    <!-- Shared Modal -->
    <products-modal
      :visible="visibleModal"
      @closeModal="visibleModal = false"
      :item="modalItem"
      :evnt-strt-dt="evntStrtDt"
      :evnt-end-dt="evntEndDt"
      parent-click-evnt-nm="clickEvnt"
      @clickEvnt="handleClickModalEvnt"
    />
  </main>
</template>
<style>
.mCS-cstmScroll .mCSB_dragger_bar {background-color:#aaa !important; transition:none !important}
.mCS-cstmScroll.mCSB_horizontal.mCSB_inside > .mCSB_container {margin-bottom:15px;}
</style>
<style scoped>
.btn-more-cont-wrap {
  margin-top:32px;
}
.btn-more-cont span:after{
  transform: rotate(-90deg);
}
.pagination { display: flex; padding-left: 0; list-style: none; justify-content: center; }
.page-item { margin: 0 2px; }
@media(max-width:800px) {
  .btn-more-cont-wrap {
    margin-top:24px;
  }
}
</style>

<style>
.page-category.main { padding-bottom:0; }
.gray-bg { padding:60px 0; width:100%; background-color:#F5F5F5; }
.gray-bg .in-container { margin:0 auto; padding: 0 24px; width:100%; max-width:1368px; }
.scroll_box::-webkit-scrollbar { height: 4px; }
.scroll_box::-webkit-scrollbar-track { background: #E4E4E4; }
.scroll_box::-webkit-scrollbar-thumb { background-color: #AAAAAA; border-radius: 10px; border: 2px solid #aaa; background-clip: content-box; }
.scroll_box::-webkit-scrollbar-thumb:hover { background-color: #AAAAAA; }
.category-wrap {position:relative;}
.category-top { display:flex; align-items: center; position:absolute; top:-1px; right:0; }
.category-top > * { position:relative; }
.category-top > * + * { margin-left:16px; padding-left:16px; }
.category-top > * + *:before { position:absolute; top: calc(50% - 8px); left:0; content:""; width:1px; height:16px; background:#aaa; }
/* Search Bar */
.category-search { /*  position:absolute; top:0; right:24px; */ margin: 0; padding: 0; width:100%; max-width:280px; }
/* .category-search-button { position: relative; border: 0; width:40px; height:40px; background: none; cursor: pointer; }
.category-search-button .icon { position: relative; width: 32px; height: 32px; } */

/* Category Filters */
.category-items { width:auto; max-width:1280px; margin-bottom:0; padding: 24px 0 16px; }
.category-items-list { display: flex; flex-wrap: nowrap; justify-content: flex-start; gap: 24px; }
.category-items-list-li { list-style: none; }
.category-item { display: flex; align-items: center; cursor: pointer; }
.category-item .category-item-img:hover { background: #fff; color: #153598; border: 2px solid #153598; }
.category-items .category-item:hover,
.category-items .category-item:focus { color: #153598; }
.category-item.is-active { border-bottom:3px solid #153598; background: none; }

.mutual-event { overflow-x:auto; width: auto; max-width:1280px; /* max-width: 1159px; */ padding: 24px 0 4px; /* -ms-overflow-style: none; scrollbar-width: none; */ }
.mutual-event,
.category-items,
.scroll_box{ overflow-x: auto; -webkit-overflow-scrolling: touch; white-space: nowrap; }


.mutual-event::-webkit-scrollbar,
.category-items::-webkit-scrollbar,
.scroll_box::-webkit-scrollbar { height: 4px; background: #E4E4E4; }


.mutual-event::-webkit-scrollbar-track,
.category-items::-webkit-scrollbar-track,
.scroll_box::-webkit-scrollbar-track { background: #E4E4E4; }

.mutual-event::-webkit-scrollbar-thumb,
.category-items::-webkit-scrollbar-thumb,
.scroll_box::-webkit-scrollbar-thumb{ background-color:#AAAAAA; border-radius: 10px; border: 2px solid #aaa; background-clip: content-box; }

.mutual-event::-webkit-scrollbar-thumb:hover
.category-items::-webkit-scrollbar-thumb:hover,
.scroll_box::-webkit-scrollbar-thumb:hover { background-color:#AAAAAA; }

.mutual-event-list .category-items-list-li .category-item-img:hover{ border: none }

.mutual-event-list { display: flex; flex-wrap: nowrap; justify-content: center; }


.mutual-event-list .item-title { font-size: 14px; }

.mutual-event-list .category-items-list-li { flex:1; width:66px; height:66px; /* margin-right:44px; */ list-style: none; }

.mutual-event-list .category-item { display: flex; flex-direction: column; align-items: center; text-decoration: none; color: inherit; }

.mutual-event-list .category-item-img { width: 66px; height: 66px; display: flex; align-items: center; justify-content: center; }
.mutual-event-list .category-item-img:hover{ background:none }

.category-items .category-item:hover .category-item-img,
.category-items .category-item:focus .category-item-img,
.category-item.is-active .category-item-img { border: 2px solid #008775; }
.category-items-list .item-title { font-size: 22px; line-height: 1.5; display: inline-block; }

.category-items-list.type02 .item-title { display: inline-flex; align-items: center; font-size: 15px; display: inline-block; }
.scroll_box { padding-bottom:6px; }
/* PC Styles */ 
/* .products-item { width:calc(16.666% - 17px); box-sizing: border-box;} // Moved to page.products.scss */

.placeholder-div-right20 { position: absolute; right: 0; top: 20px; }
.sort-options { position: relative; display: flex; /* gap: 21px; */ }
.sort-options .button { padding: 8px 12px; border: 1px solid #ddd; border-radius:8px; background-color: transparent; cursor: pointer; font-size: 16px; color: #8e8e8e; height: unset; width: unset; flex: unset; min-width: unset; font-weight: 400; overflow: visible; background-color:#fff; transition:all 0.3s ease; }
.sort-options .button.low-price { border-top-right-radius: 0; border-bottom-right-radius: 0; }
.sort-options .button.high-price { margin-left:-1px; border-top-left-radius: 0; border-bottom-left-radius: 0; }
.sort-options .button.is-active { font-weight: 700; background-color: #153598; border-color: #153598; /* background-color: #a7aec4; border-color: #a7aec4; */ }
.sort-options .button.is-active div{ color: #fff; }
.sort-options .button:first-child { display: none; }
.sort-options .button:nth-child(2)::before { content: ""; display: inline-block; position: absolute; width: 1px; height: 12px; background: #d8d8d8; left: -11px; display: none; }
.sort-options .button div { display: inline-flex; align-items: center; font-size:13px; color:#717171; font-weight:700; line-height:1.5; }

.category-items-list.type02 { margin-top: 16px; display: flex; justify-content: flex-start; gap:16px; width: auto; /* overflow-x: auto; */ -webkit-overflow-scrolling: touch; white-space: nowrap }
.category-items-list.type02 .category-items-list-li { flex: 0 0 auto !important; display: inline-flex; }

.category-items-list.type02 .category-items-list_li .category-item { display: inline-flex; align-items: center; padding: 0 16px; height: 36px; border-radius: 999px; border: 1px solid #d8d8d8; transition:all 0.3s ease; }
.category-items-list.type02 .category-items-list_li .category-item.is-active,
.category-items-list.type02
.category-items-list_li
.category-item.is-active
.item-title { background: #153598; border: 1px solid #153598; color: #fff !important; }

.category-items-list.type02
.category-items-list-li
.category-item.is-active span { color: #fff; }

/* Mobile Styles */ 
.msection-content { position: relative; }
.msection .gray-bg { margin-top:0; }
.realtime-item { display: block; text-decoration: none; color: inherit; }
.realtime-content { background: #fff; /* border-radius: 8px; */ overflow: hidden; }
.content-img img { width: 100%; height: 150px; object-fit: cover; }
.button-like { background: none; border: none; cursor: pointer; padding: 0; /* 패딩 제거 */ }
.button-like .icon { font-size: 20px; /* 아이콘 크기 조정 */ }

/* Swiper Custom Styles (Mobile) */
/* .swiper { width: 100%; overflow: hidden; position: relative; }
.swiper-slide { flex-shrink: 0; width: 100%; height: auto; position: relative; transition-property: transform; }
.realtimeslide { display: flex; justify-content: center; padding: 0 10px; box-sizing: border-box; } */

/* Mobile Page Controls */
.mobile-page-controls { display: flex; height: 36px; justify-content: center; align-items: center; gap: 10px; margin-top: 24px; }
.page-nav-button { display: flex; width: 36px; height: 36px; padding: 14px; justify-content: center; align-items: center; gap: 10px; font-size: 0; background: url("~@/assets/img/common/btn_arrow-right.svg") no-repeat 0 0; }
.page-nav-button.prev { transform: rotate(180deg); }
.page-nav-button:hover:not(:disabled) { background-color: #ddd; }
.page-nav-button:disabled { background: url("~@/assets/img/common/btn_arrow-left_disabled.svg") no-repeat 0 0; cursor: not-allowed; }
.page-nav-button.prev:disabled { transform: rotate(360deg); }
.page-info { font-size: 16px; font-style: normal; font-weight: 400; line-height: 18px; /* letter-spacing: 3.2px; */ /* 제거 또는 조정 */ border-radius: 99px; border: 1px solid #e0e0e0; background: #fff; height: 36px; display: inline-flex; align-items: center; /* width: 61px; */ /* 너비 자동 조정 */ padding: 0 12px; /* 좌우 패딩 추가 */ justify-content: center; }
.page-info .current-page { font-weight: 700; color: #008775; }
.page-info .separator { margin: 0 4px; color: #888; }
.page-info .total-pages { color: #555; }
.no-data-message { padding: 76px 0; width:100%; text-align: center; line-height:1.5; font-size:32px; color: #8e8e8e; }

/* Pagination (PC) */
.pagination-wrap { margin-top: 40px; text-align: center; }


.mutual-event-list .category-items-list-li a{ display: flex; width: 100%; height: 100%; margin-bottom:0 !important; justify-content: center; align-items: center; flex-shrink: 0; }
.mobile-product-item { min-width: 100%; max-width: 100%; width:100%; }

/* Responsive Design */
@media screen and (max-width: 800px) {
  .scroll_box::-webkit-scrollbar,
  .category-items-list.type02::-webkit-scrollbar { height: 4px; }
  .scroll_box::-webkit-scrollbar-track,
  .category-items-list.type02::-webkit-scrollbar-track { background: #E4E4E4; }
  .scroll_box::-webkit-scrollbar-thumb,
  .category-items-list.type02::-webkit-scrollbar-thumb { background-color: #aaa; border-radius: 10px; border: 2px solid #aaa; background-clip: content-box; }
  .scroll_box::-webkit-scrollbar-thumb:hover,
  .category-items-list.type02::-webkit-scrollbar-thumb:hover { background-color: #aaa; }
  .mutual-event-list .item-title { font-size: 14px; }
  .mutual-event-list.scrollable
  .scroll_box { display: flex; flex-wrap: nowrap; overflow-x: auto; justify-content: flex-start; padding-left: 0; padding-bottom: 10px; margin-right: -16px; -webkit-overflow-scrolling: touch; /* scrollbar-width: none; */ /* Firefox에서 스크롤바 숨기기 */ /* -ms-overflow-style: none; */ /* IE에서 스크롤바 숨기기 */ width: auto;; }

::v-deep(.mutual-event::-webkit-scrollbar),
::v-deep(.category-items::-webkit-scrollbar),
::v-deep(.scroll_box::-webkit-scrollbar) { height: 4px; }

::v-deep(.mutual-event::-webkit-scrollbar-track),
::v-deep(.category-items::-webkit-scrollbar-track),
::v-deep(.scroll_box::-webkit-scrollbar-track) { background: #E4E4E4; }

::v-deep(.mutual-event::-webkit-scrollbar-thumb),
::v-deep(.category-items::-webkit-scrollbar-thumb),
::v-deep(.scroll_box::-webkit-scrollbar-thumb) { background-color: #aaa; border: 2px solid #aaa; background-clip: content-box; }

::v-deep(.mutual-event::-webkit-scrollbar-thumb:hover),
::v-deep(.category-items::-webkit-scrollbar-thumb:hover),
::v-deep(.scroll_box::-webkit-scrollbar-thumb:hover) { background-color: #aaa; }
  .realtime-item { display: block; background: #fff; /* border-radius: 16px; */ overflow: hidden; width: 100%; /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); */ text-decoration: none; color: inherit; }
  .content-img img { width: 100%; height: auto; aspect-ratio: 1/1; /* 이미지 비율 1:1로 유지 */ object-fit: cover; display: block; }
  .category-search-area { margin: 0 auto; }
  .page-navigation { display: flex; justify-content: center; }

  
  /* .page-link { position: relative; display: block; padding: 0.5rem 0.75rem; line-height: 1.25; color: #333; background-color: #fff; border: 1px solid #e0e0e0; border-radius: 50%; width: 36px; height: 36px; font-size: 14px; text-align: center; padding: 0; line-height: 36px; } */
  .page-item.active .page-link { z-index: 3; color: #fff; background-color: #008775; border-color: #008775; }
  /* .page-item.disabled .page-link { color: #ccc; pointer-events: none; cursor: not-allowed; background-color: #fff; border-color: #e0e0e0; } */
  .icon-pagination-first,
  .icon-pagination-prev,
  .icon-pagination-next,
  .icon-pagination-last { display: inline-block; width: 16px; height: 16px; background-repeat: no-repeat; background-position: center; vertical-align: middle; }
  .category-items-list.type02 .category-items-list_li .category-item { padding: 0 20px; height: 36px; line-height: 36px; border-radius: 999px; border: 1px solid #d8d8d8; }
  .category-items-list.type02 .category-items-list_li .category-item.is-active,
  .category-items-list.type02
  .category-items-list_li
  .category-item.is-active
  .item-title { background: #153598; border: 1px solid #153598; color: #fff !important; font-weight: 700; }
  .category-items-list.type02 .category-items-list_li { flex: 0 0 auto; width: auto; margin-bottom: 0; }
  .category-items-list.type02 .category-items-list_li:nth-child(even) { margin-left: 0; margin-bottom: 0; }
  .category-items-list.type02 .category-items-list-li .category-item { width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; box-sizing: border-box; padding: 8px 0; border-radius: 8px; }


  .category-items .category-items-list-li:nth-child(1) .category-item-img img { width: 32px; height: 32px; }
  .category-items .category-items-list-li:nth-child(2) .category-item-img img { width: 36px; height: 48px; }
  .category-items .category-items-list-li:nth-child(3) .category-item-img img { width: 39px; height: 40px; }
  .category-items .category-items-list-li:nth-child(4) .category-item-img img { width: 43px; height: 42px; }
  .category-items .category-items-list-li:nth-child(5) .category-item-img img { width: 43px; height: 36px; }
  .category-items .category-items-list-li:nth-child(6) .category-item-img img { width: 52px; height: 48px; }

  .placeholder-div-right20 { position: unset; }

  .sort-options button:first-child { display: none; }

  /* 제품리스트 모바일전용  */
  .realtimeslide { display: flex; justify-content: center; padding: 0 10px; box-sizing: border-box; }

  .realtime-item { display: block; background: #fff; /* border-radius: 16px !important; */ overflow: hidden; width: 100%; /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); */ text-decoration: none; }

  @media (device-width: 800px) {
    .msection-wrap .msection .realtime-content .content-img{ margin-bottom:16px; }
    .realtime-item { max-width: 80%; }
  }
  .content-img img { width: 100%; height: auto; object-fit: cover; display: block; }
  .info-price { font-size: 15px; font-weight: bold; color: #222; }
  .button-like { background: none; border: none; cursor: pointer; padding: 0; display: none; }
  .button-like .icon { font-size: 18px; }
}
.mobile-products-grid{ display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px 26px; }
.msection .category-items, .msection .scroll_box  { padding-bottom:5px; /* scrollbar-width: none; */ }
.footer-info-logo { margin:0 auto; padding: 0 24px; max-width:1328px; width:100%; }
@media screen and (min-width: 768px) and (max-width: 1024px) {
  /* 아이패드 공통 스타일 */
  .popup-product-info__desc .group label + div{ font-size: 17px; }
  .scroll_box::-webkit-scrollbar,
  .category-items-list.type02::-webkit-scrollbar { height: 4px; }
  .scroll_box::-webkit-scrollbar-track,
  .category-items-list.type02::-webkit-scrollbar-track { background: #E4E4E4; }
  .scroll_box::-webkit-scrollbar-thumb,
  .category-items-list.type02::-webkit-scrollbar-thumb { background-color: #aaa; border-radius: 10px; border: 2px solid #aaa; background-clip: content-box; }
  .scroll_box::-webkit-scrollbar-thumb:hover,
  .category-items-list.type02::-webkit-scrollbar-thumb:hover { background-color: #aaa; }
}
@media(max-width: 1024px) {
  .category-search-area { max-width:380px; }
  .mobile-products-grid{ grid-template-columns: repeat(3, 1fr); }
  .msection ::-webkit-scrollbar { display:none; }
  .msection .mutual-event, 
  .msection .category-items,
  .msection .scroll_box { -ms-overflow-style: none; /* IE, Edge */ scrollbar-width: none; }
}
@media(max-width:902px) {
  .mutual-event-list {justify-content: flex-start;}
}
@media(max-width: 900px) {
  .msection-content { margin-top:0; }
  .mobile-products-grid{ grid-template-columns: repeat(2, 1fr); gap: 24px 10px; }
  .gray-bg .in-container { padding: 0 16px; }
  .mutual-event { padding:16px 0 4px; }
  .mutual-event-list .category-items-list-li,
  .mutual-event-list .category-item-img { width:72px; height:72px; }
  .mutual-event-list .category-items-list-li { margin-right:10px; }
  .category-wrap { margin-top:0px; }
  .mutual-event::-webkit-scrollbar,
  .scroll_box::-webkit-scrollbar,
  .category-items::-webkit-scrollbar { background:#E4E4E4; }
  .mutual-event::-webkit-scrollbar-thumb,
  .category-items::-webkit-scrollbar-thumb,
  .scroll_box::-webkit-scrollbar-thumb { background:#aaa; }
  .category-top { flex-direction: column; align-items: flex-start; position:initial; margin-top:24px; }
  .category-top > * + * { padding-left:0; }
  .category-top > * + *:before { content:none; }
  .category-search { max-width:100% }
  .category-search-area { width:100%; max-width:100%; }
  .sort-options { margin:24px 0 10px auto; }
  .sort-options .button div { font-size: 16px; }
  .category-items-list { gap:8px }
  .category-items { padding:24px 0 5px; /* scrollbar-width: none; */ }
  .category-items .category-item .item-title { font-size: 18px; }
  .category-items-list.type02 { gap:8px; }
  .category-items-list.type02 .item-title { font-size:14px; }
}
.category-title { font-size: 24px; font-weight: 700; margin-bottom: 24px; color: #1D1D1D; font-family: "Pretendardgov"; }


/***** 2026 추가 *****/
/* .m1024Block {display:none;}
@media(max-width:1024px) {
  .m1024None {display:none;}
  .m1024Block {display:block;}
}
@media(max-width:800px) {
  .mbBorderNone {border-bottom:none !important;}
} */

.borderB {border-bottom:1px solid #ccc;}

.moOnly {display:none;}
@media(max-width:800px) {
  .moOnly {display:block;}
}

/* 202603 검색영역 */
.btn-shortcut-wrap {position:absolute; right:24px;}
.srchBoxWrap .container {position:relative;}
.srchBoxWrap {padding:30px 0;}
.srchBoxWrap h2 {margin-bottom:60px; text-align:center; font-size:44px;}
.srchBoxWrap .inFlexBox {display:flex; justify-content: center; gap:0 100px;}
.srchAreaWrap {flex:0 1 614px;}
.srchAreaWrap > span {display:block; margin-bottom:24px; text-align:center; font-size:30px; font-weight:400; color:#1d1d1d; font-family: 'Gmarket Sans';}
.srchAreaWrap .srchArea {display:flex; padding:0 16px; border-bottom:3px solid #075D5D;}
.srchAreaWrap .srchArea input[type="text"] {border:none; width:100%; height:53px; font-size:19px; color:#1d1d1d;}
.srchAreaWrap .srchArea input[type="text"]::placeholder {font-size:19px; color:#8E8E8E; font-weight:500;}
.srchAreaWrap .srchArea button {width:30px; height:53px; text-indent:-9999px; color:transparent; background:url("../../assets/img/main/ico-main-search.svg") no-repeat center;}
.hashTagArea {flex:0 1 587px}
.hashTagArea > ul {display:flex; flex-wrap: wrap; justify-content:center; gap:10px;}
.hashTagArea > ul li a {display:block; padding:10px 16px; border-radius:999px; font-size:17px; color:#fff; font-weight:500; background-color:#6AAE3F;}
.hashTagArea .bgRed {background-color:#EF3F36}
.hashTagArea .bgOrng {background-color:#FF8A0C}
.hashTagArea .bgDgreen {background-color:#075D5D}
.hashTagArea .bgBlue {background-color:#2E6CDF}
@media(max-width:1024px) {
  .srchBoxWrap h2 {margin-bottom:42px; font-size:38px;}
  .srchBoxWrap .inFlexBox {gap:20px;}
  .srchAreaWrap > span {font-size:24px;}
  .hashTagArea p> ul {gap:8px;}
  .hashTagArea > ul li a {font-size:16px;}
}
@media(max-width:948px) {
  .btn-shortcut-wrap {top:-50px;}
}
@media(max-width:900px) {
  .btn-shortcut-wrap {right:16px;}
}
@media(max-width:800px) {
  .btn-shortcut-wrap {top:-42px;}
  .btn-shortcut-wrap a {padding:6px 16px !important;}
  .srchBoxWrap {padding:10px 0;}
  .srchBoxWrap .inFlexBox {flex-direction: column; gap:32px}
  .srchBoxWrap h2 {margin-bottom:24px; line-height:1.2; font-size:32px;}
  .srchAreaWrap {flex:initial;}
  .srchAreaWrap > span {margin-bottom:10px; font-size:17px;}
  .srchAreaWrap .srchArea {margin: 0 auto; width: 80%;}
  .srchAreaWrap .srchArea input[type="text"] {height:40px;}
  .srchAreaWrap .srchArea button {height:40px;}
  .hashTagArea {flex:initial;}
  .hashTagArea > ul {gap:6px;}
  .hashTagArea > ul li a {padding:10px; font-size:15px;}
}

/* 2603 온라인 상품전 참여 쇼핑몰 */
.gray-bg .inFlexBox {display:flex; justify-content: space-between; align-items:center; gap:20px;}
.gray-bg .inFlexBox h2 {flex:0 0 194px; font-size:32px;}
.gray-bg .inFlexBox .shop-list-wrap {overflow-x:auto; overflow-y: hidden; padding-bottom: 4px;}
.gray-bg .inFlexBox .shop-list-wrap::-webkit-scrollbar {height: 4px;}
.gray-bg .inFlexBox .shop-list-wrap::-webkit-scrollbar-track {background-color: #E4E4E4; border-radius: 999px; } 
.gray-bg .inFlexBox .shop-list-wrap::-webkit-scrollbar-thumb { background-color: #075D5D; border-radius: 999px; }
.gray-bg .inFlexBox .shop-list {display:flex; gap:14px;}
.gray-bg .inFlexBox .shop-list-li {min-width:66px;}
.gray-bg .inFlexBox .shop-list-li .shop-list-item > span {display:block; margin-top:6px; text-align: center; font-size:15px; color:#2d2d2d;}
@media(max-width:800px) {
  .gray-bg { padding:40px 0;}
  .gray-bg .inFlexBox {flex-direction: column; gap:16px;}
  .gray-bg .inFlexBox h2 {flex:initial; align-self:flex-start; font-size:20px;}
  .gray-bg .inFlexBox h2 br {display:none;}
  .gray-bg .inFlexBox .shop-list-wrap {width:100%;}
  .gray-bg .inFlexBox .shop-list {gap:16px;}
}

/* 식품관 상품 리스트 */
/* .rtBannerBox {display:flex; gap:20px;}
.rtBannerBox .products-item {width: calc(20% - 16px);}
.rtBannerBox [class *= "category-title-box"]{width: calc(40% - 12px);}
.rtBannerBox .rtBanner {min-width:calc(16.666% - 17px);}
.rtBannerBox .rtBanner a {display:block;}
@media(max-width:1024px) {
  .rtBannerBox .products-item {width:calc(25% - 15px);}
  .rtBannerBox [class *= "category-title-box"] {width: calc(50% - 10px);}
  .rtBannerBox .rtBanner {min-width:calc(20% - 16px);}
}
@media(max-width:800px) {
  .category-section.rtBannerBox {padding:40px 0 0;}
  .rtBannerBox {flex-direction: column; gap:40px;}
  .rtBannerBox .products-item {width:calc(50% - 5px);}
  .rtBannerBox [class *= "category-title-box"] {width:100%;}
  .rtBannerBox .rtBanner {width:100%;}
  .rtBannerBox .rtBanner img {content:url("../../assets/img/main/right-banner01-m.png");width:100%;}
} */

/* 2603 온라인 이벤트 배너 */
/* .event-banner-wrap a {display:block;}
.event-banner-wrap img {width:100%;}
@media(max-width:800px) {
  .event-banner-wrap img {content:url("../../assets/img/main/event-banner01-m.png")}
} */

/* 2603 Hot5 상품 */
/* .best-item-wrap {padding:80px 0; background:#F5F5F5;}
.best-item-wrap .in-box {padding:40px; border-radius:30px; background-color:#fff;}
.best-item-wrap .in-box h2 {margin-bottom:20px; font-weight:400;}
.best-item-wrap .in-box h2 b {font-weight:700;}
.best-item-wrap .in-box > p {line-height:1.4; font-size:19px; color:#444;}
.best-item-wrap .in-box > p b {font-weight:700;}
.best-item-swiper {margin-top:20px;}
.best-item-swiper .swiper-slide a {display:block; height:100%;}
.best-item-swiper .swiper-slide .img-wrap {position:relative; overflow:hidden; border-radius:10px; margin-bottom:10px; aspect-ratio: 1;}
.best-item-swiper .swiper-slide .img-wrap a > span {display:inline-block; position:absolute; left:0; top:0; z-index:-1; padding:0 10px; border-radius: 0 0 10px 0; min-width:72px; letter-spacing:-0.38px; text-align:center; line-height:30px; font-size:19px; color:#fff; font-weight:700; background: #F00;}
.best-item-swiper .swiper-slide .img-wrap a img {position:absolute; left:50%; top:50%; z-index:-2; width:100%; height:100%; object-fit: cover; transform: translate(-50%, -50%);}
.best-item-swiper .swiper-slide .img-wrap .btn-wrap {display:flex; gap:4px; position:absolute; right:12px; bottom:12px; z-index:3;}
.best-item-swiper .swiper-slide .img-wrap .btn-wrap > * {width:30px; height:30px; text-indent: -9999px; color:transparent; background:no-repeat center;}
.best-item-swiper .swiper-slide .img-wrap .btn-wrap .btn-share {background-image:url("../../assets/img/main/ico-share01.svg")}
.best-item-swiper .swiper-slide .img-wrap .btn-wrap .btn-like {background-image:url("../../assets/img/main/ico-like01.svg")}
.best-item-swiper .swiper-slide .img-wrap .btn-wrap .btn-like.on {background-image:url("../../assets/img/main/ico-like01-on.svg")}
.best-item-swiper .swiper-slide .txt-wrap span {display:block;}
.best-item-swiper .swiper-slide .txt-wrap .best-item-company {margin-bottom:5px; letter-spacing: -0.3px; line-height:1.2; font-size:15px; color:#153598; font-weight:700;}
.best-item-swiper .swiper-slide .txt-wrap .best-item-title {display:-webkit-box; -webkit-box-orient:vertical; -webkit-line-clamp:2; overflow:hidden; margin-bottom:10px; height:40px; text-overflow:ellipsis; letter-spacing: -0.34px; line-height: 1.2; font-size:17px; color:#444; font-weight:500;}
.best-item-swiper .swiper-slide .txt-wrap .best-item-price {line-height:1.2; font-size:21px; color:#1d1d1d; font-weight:700;}
.best-item-swiper .swiper-slide .total-wrap {display:flex; gap:6px 24px; margin-top:10px; padding-top:10px; border-top:1px solid #ccc;}
.best-item-swiper .swiper-slide .total-wrap > * {display:inline-block; position: relative; padding-left:24px; letter-spacing:-0.3px; line-height:20px; font-size:15px; color:#f00; font-weight:500; background:no-repeat left center;}
.best-item-swiper .swiper-slide .total-wrap > * + *:before {position: absolute; left:-11px; top:calc(50% - 8px); content:""; width:1px; height:16px; background:#ccc;}
.best-item-swiper .swiper-slide .total-wrap > .like-total {background-image:url("../../assets/img/main/ico-like02.svg")}
.best-item-swiper .swiper-slide .total-wrap > .share-total {background-image:url("../../assets/img/main/ico-share02.svg")}
@media(max-width:1024px) {
  .best-item-wrap .in-box > p {font-size:17px;}
}
@media(max-width:860px) {
  .best-item-swiper .swiper-slide .total-wrap {flex-direction: column;}
  .best-item-swiper .swiper-slide .total-wrap > * + *:before {content:none;}
}
@media(max-width:800px) {
  .best-item-wrap {padding:60px 0;}
  .best-item-wrap .in-box {padding:40px 16px;}
  .best-item-wrap .in-box > p {font-size:15px;}
  .best-item-swiper .swiper-slide .img-wrap a > span {min-width:60px; line-height:24px; font-size:15px;}
  .best-item-swiper .swiper-slide .txt-wrap .best-item-title {-webkit-line-clamp: 3; height:60px;}
} */

/* 2603 동행축제 영상보기, 소비이벤트 */
/* .promo-section {padding:80px 0;}
.promo-section h2 {margin-bottom:20px; padding-right: 66px; font-weight:400;}
.promo-section h2 b {font-weight:700;}
.promo-section .inFlexBox {display:flex; gap:56px;}
.promo-section .inFlexBox > * {position:relative; flex:1;}
.promo-section .inFlexBox > * > a {position:absolute; top:16px; right:0; padding-right:20px; line-height:24px; font-size:17px; color:#666; font-weight:500; background:url("../../assets/img/main/ico-more01.png") no-repeat right center}
.promo-section .promo-card .in-cont {overflow:hidden; border-radius:16px; aspect-ratio: 770/400;}
.promo-section .video-card .in-cont {overflow:hidden; border-radius:16px; aspect-ratio: 770/400;}
.promo-section .video-card .in-cont a {display:block;}
.promo-section .video-card .in-cont img,
.promo-section .video-card .in-cont iframe {width:100%; height: 100%;}
.promo-section .event-banner .in-cont img {width:100%; height:100%; object-fit: cover;}
@media(max-width:1280px) {
  .promo-section .inFlexBox {gap:20px;}
  .promo-section h2 {font-size:30px;}
}
@media(max-width:1024px) {
  .promo-section .inFlexBox {flex-direction: column; gap:60px;}
  .promo-section h2 {font-size:32px;}
  .promo-section .video-card .in-cont {aspect-ratio: 16/9;}
  .promo-section .event-banner .in-cont {aspect-ratio: 343/193;}
}
@media(max-width:800px) {
  .promo-section {padding:60px 0;}
} */
</style>

<script>
import { mapGetters } from "vuex";
import $ from 'jquery';
import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
import {
  ACT_GET_COMMON_CODE_LIST,
  ACT_GET_CAMPN_MANPRD_LIST,
  ACT_UPDATE_CAMPN_MANPRD_FAVR,
  ACT_GET_DHFESTA_EVENT_MNG,
  ACT_GET_SUB_CTGR_CODE_LIST,
  ACT_INCREASE_MANPRD_SHARE_COUNT,
} from "@/store/_act_consts";
import {
  MUT_SET_RETURN_ROUTE,
  MUT_SHOW_CONFIRM,
  MUT_SHOW_ALERT,
} from "@/store/_mut_consts";
import {
  getItem,
  getItems,
  lengthCheck,
  getCheckItems,
  tryResCallback,
  queryToValue,
  isSuccess,
  timestampToDateFormat,
  dateToDateFormat,
} from "@/assets/js/utils";
import { countDDay } from "@/assets/js/DateUtils";
import PortalPagination from "@/components/PortalPaginationRoute";
import PageHeader from "@/components/content/PageHeader";
import ProductsModal from "@/components/content/ProductsModal";
import ProductsItem from "@/components/content/ProductsItem";
import Icon from "@/components/common/Icon";
// Swiper import 추가
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "MainRealtimeDibs",
  components: {
    // Swiper, SwiperSlide 추가
    Swiper,
    SwiperSlide,
    PortalPagination, // PC용은 유지
    PageHeader,
    ProductsItem,
    ProductsModal,
    Icon,
  },
  data: () => ({
    pagingMethodName: "getManprdList",
    pageListSize: 10, // PC 페이지네이션 크기
    manprdList: [], // PC 화면에 표시될 상품 목록 (페이지네이션 적용)
    manprdFilterList: [], // PC 필터링/정렬된 전체 목록 (페이지네이션 전)
    originalFilteredList: [], // 필터링만 적용된 원본 목록 (정렬 전)
    manprdAllList: [], // 서버에서 가져온 전체 원본 데이터
    pageNo: 1, // 현재 페이지 번호 (PC/모바일 공통 사용)
    pageSize: 16, // 페이지당 아이템 수 (PC/모바일 다름, watcher에서 설정)
    totalCount: 0, // 전체 상품 수 (필터링 적용 후)
    searchName: "", // 검색어
    visibleModal: false, // 모달 표시 여부
    ctgrDcd: "", // 선택된 메인 카테고리 코드
    subCtgrDcd: "", // 선택된 서브 카테고리 코드
    ctgrItems: [], // 메인 카테고리 목록
    mutualDisEventListPC: [], // 상생할인전 목록
    mutualDisEventListMobile: [], // 상생할인전 목록
    modalId: 0, // 모달에 표시할 상품 ID
    modalType: "", // 사용 안 함
    allManprdList: [], // 필터링/정렬된 전체 상품 목록 (PC 원본 데이터) -> 이 변수는 manprdAllList와 중복되어 보임. 정리 필요
    evntStrtDt: "", // 이벤트 시작일
    evntEndDt: "", // 이벤트 종료일
    sortCd: "", // 정렬 코드 (F: 추천, PU: 가격↑, PD: 가격↓)
    subCodeList: [], // 전체 서브 카테고리 목록
    selectCodeList: [], // 현재 선택된 메인 카테고리에 따른 서브 카테고리 목록
    // Swiper 관련 data 추가
    // thisSwiper: null, // Swiper 인스턴스 (mounted에서 할당)
    activeIndex: 0, // 현재 활성 슬라이드 인덱스 (Swiper 내부 기준)
    swiperOption: {
      slidesPerView: 2, // 한 번에 2개 표시
      spaceBetween: 12, // 슬라이드 간 간격
      slidesPerGroup: 2, // 2개씩 그룹으로 넘김 (선택 사항)
      pagination: false, // Swiper 자체 페이지네이션 비활성화
      navigation: false, // Swiper 자체 네비게이션 비활성화
      // Responsive breakpoints (선택 사항)
      // breakpoints: { ... },
      on: {
        // --- 수정: 화살표 함수 -> 일반 함수 ---
        ready: function (swiper) {
          // console.log("Swiper ready, this:", this); // 'this'는 Vue 인스턴스
        },
        slideChange: function () {
          // console.log("Slide changed, this:", this); // 'this'는 Vue 인스턴스
          if (this.swiperInstance) {
            // computed 속성 접근
            this.activeIndex = this.swiperInstance.realIndex;
          } else {
            // console.warn("Swiper instance not available during slideChange");
          }
        },
        // --- 수정 끝 ---
      },
    },
    bestItemOption: {
      slidesPerView: 5,
      slidesPerGroup:1,
      spaceBetween: 20,
      navigation: false,
      breakpoints: {
        1161: { slidesPerView: 5 },
        768: { slidesPerView: 3 },
        0: { 
          slidesPerView: 2,
          spaceBetween: 10,
        },
      },
    },
    isDraggingMutualEvent: false,
    startXMutualEvent: 0,
    scrollLeftMutualEvent: 0,
    hasDraggedMutualEvent: false, // 드래그 발생 여부 플래그
    searchFlag: true,
    mostLikedProducts: [],

  }),
  computed: {    
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    ...mapGetters("auth", ["session", "isAuth"]),
    // 동행축제 영상보기 URL
    videoUrl() {
       const videoId = "KLuHbKFtSoM"; 
       return `https://www.youtube.com/embed/${videoId}?si=Rl9N0LlC5vDSw_jx&playlist=${videoId}&loop=1&autoplay=1&mute=1`;
    },
    campnId() {
      return this.campn?.campnId;
    },
    modalItem() {
      if (this.modalId > 0) {
        // 모달 아이템은 전체 원본 목록(manprdAllList)에서 찾음
        return this.manprdAllList.find((i) => i.id == this.modalId);
      }
      return null;
    },
    queries() {
      // PC 페이지네이션용 쿼리
      const result = {};
      result.searchName = this.searchName;
      result.ctgrDcd = this.ctgrDcd;
      return result;
    },
    // Swiper 인스턴스 접근 (ref 사용)
    swiperInstance() {
      // $swiper 접근은 vue-awesome-swiper v3 기준
      return this.$refs.realtimeSwiper?.$swiper;
    },
    // 모바일 페이지네이션용 totalPages (복원)
    totalPages() {
      if (!this.totalCount || this.pageSize <= 0) {
        return 0;
      }
      // pageSize는 모바일 4, PC 16
      return Math.ceil(this.totalCount / this.pageSize);
    },
    // 모바일 Swiper에 표시될 현재 페이지 아이템 목록 (복원)
    currentPageItems() {
      // allManprdList는 필터링/정렬된 목록
      if (!this.allManprdList || this.allManprdList.length === 0) {
        return [];
      }
      const start = (this.pageNo - 1) * this.pageSize; // pageSize는 모바일 4, PC 16
      const end = start + this.pageSize;
      const items = this.allManprdList.slice(start, end);

      // Swiper 업데이트 트리거 (DOM 업데이트 후, 모바일일 때만)
      // if (this.isMobile) {
      //   this.$nextTick(() => {
      //     // swiperInstance computed 속성 사용 및 존재 확인
      //     if (this.swiperInstance && !this.swiperInstance.destroyed) {
      //       this.swiperInstance.update(); // 슬라이드 데이터 변경 시 Swiper 업데이트
      //
      //       // --- 추가: 페이지 변경 시 첫 슬라이드로 이동 ---
      //       // 주의: 이 로직은 currentPageItems가 pageNo 변경 외의 이유로
      //       // 재계산될 때도 실행될 수 있으므로, 의도치 않은 이동이 발생할 수 있습니다.
      //       // Watcher 방식이 더 안정적일 수 있습니다.
      //       this.swiperInstance.slideTo(0, 0); // 첫 번째 슬라이드로 즉시 이동
      //       // --- 추가 끝 ---
      //     }
      //   });
      // }
      return items;
    },
    isShowBtn() {
      return new Date() > new Date("2026-01-01 00:00:00") &&
        new Date() < new Date("2026-11-30 23:59:59");
    },
    isShowDiscountText() {
      return new Date() < new Date("2026-04-11 09:00:00") ||
        new Date() >= new Date("2026-05-10 00:00:00");
    },
    beautyList() {
      return this.manprdAllList.filter(item => item.ctgrDcd === '1501001').slice(0, 10);
    },
    livingList() {
      return this.manprdAllList.filter(item => item.ctgrDcd === '1501008').slice(0, 10);
    },
    foodList() {
      return this.manprdAllList.filter(item => item.ctgrDcd === '1501003').slice(0, 10);
    },
  },
  watch: {
    isMobile(newVal, oldVal) {
      // 화면 크기 변경 시 pageSize, pageListSize 조정 및 데이터 재로드/정렬
      this.pageSize = newVal ? 18 : 16; // 모바일 4개, PC 16개
      this.pageListSize = newVal ? 5 : 10; // 모바일 페이지네이션 버튼 수, PC 페이지네이션 버튼 수
      this.pageNo = 1; // 화면 전환 시 1페이지로 초기화

      this.$nextTick(() => {
        if (newVal) {
          // 모바일로 전환 시
          this.applySort(); // 정렬 적용 (currentPageItems 갱신 및 Swiper 업데이트 트리거)
          this.initSwiper(); // Swiper 초기화 시도
        } else {
          // PC로 전환 시
          // this.destroySwiper(); // Swiper 파괴
          this.getManprdList(1); // PC 목록 로드
        }
      });
    },
    // --- pageNo Watcher 추가 ---
    pageNo(newPage, oldPage) {
      // 모바일 환경이고 페이지 번호가 실제로 변경되었을 때만 실행
      if (this.isMobile && newPage !== oldPage) {
        this.$nextTick(() => {
          // thisSwiper 인스턴스가 유효한지 확인
          if (this.thisSwiper && !this.thisSwiper.destroyed) {
            // Swiper 업데이트 (선택 사항: currentPageItems에서 이미 처리될 수 있음)
            // this.thisSwiper.update();
            this.thisSwiper.slideTo(0, 0); // 첫 번째 슬라이드로 즉시 이동 (속도 0)
          }
        });
      }
    },
    // --- visibleModal Watcher 추가 ---
    visibleModal(isVisible) {
      if (isVisible) {
        this.layerScrollTop = window.scrollY;

        // 스크롤바 너비 계산
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        document.body.style.paddingRight = `${scrollbarWidth}px`; // 스크롤바 너비만큼 패딩 추가

        // 모바일 크롬에서 body에 스크롤 생기는 이슈 해결
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.layerScrollTop}px`;
        document.body.style.width = '100%';
        
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            const header = document.querySelector('.header');
            if (header && this.layerScrollTop > 0) {
              header.classList.add('hd-bg');
            }
            this.setResizeEvent();
          });
        });
      } else {
        // 모달 닫힐 때 원래 상태로 복원
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';

        // 모바일 크롬에서 body에 overflow
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';

        // DOM 렌더 후 스크롤 복구
        this.$nextTick(() => {
          window.scrollTo(0, this.layerScrollTop);
          window.removeEventListener("resize", this.resizeHandler);
        });
      }
    },
    // --- Watcher 추가 끝 ---
  },
  created() {
    // 컴포넌트 생성 시 초기 설정
    this.pageSize = this.isMobile ? 18 : 16; // 초기 pageSize 설정 (모바일 4)
    this.pageListSize = this.isMobile ? 5 : 10; // 초기 pageListSize 설정
    this.ctgrDcd = queryToValue(this.$route.query.ctgrDcd, false, "");
    this.getMutualDiscountEvent();
    this.getCtgrList();
    this.getSubCtgrList();
    this.getEvntMng();
    this.fetchAllManprd(); // 초기 데이터 로드

  },
  mounted() {
    /* this.$nextTick(() => {
        $(this.$el).find(".mutual-event").mCustomScrollbar({
          axis: "x",
          theme: "dark-3",
          alwaysShowScrollbar: 2
        });
    }); */
    /* $(".custom-scrollbar").mCustomScrollbar({
      axis: "x",
      theme: "cstmScroll",
      alwaysShowScrollbar: 0,
      // autoHideScrollbar: true,
      mouseWheel:{ enable: false }
    }); */
    window.addEventListener("resize", this.handleResize);
    // 초기 로드 시 모바일이면 Swiper 초기화 시도
    // this.$nextTick(() => {
    //   if (this.isMobile) {
    //     // this.initSwiper();
    //     this.setupHorizontalScroll();
    //     this.showMainCategoryScrollHint();
    //   }
    // });
    // setTimeout(() => {
    //   if (this.isMobile) {
    //     this.setupHorizontalScroll();
    //     this.showMutualEventScrollHint();
    //     this.showMainCategoryScrollHint();
    //   }
    // }, 300);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.isDraggingMutualEvent) {
      window.removeEventListener('mousemove', this.handleMutualEventGlobalMouseMove);
      window.removeEventListener('mouseup', this.handleMutualEventGlobalMouseUp);
    }
  },
  methods: {
    handleWheelScroll(e) {
      if (e.deltaY !== 0) {
        e.currentTarget.scrollLeft += e.deltaY;
      }
    },
    // 팝업 max-height
    setLayerHeight() {
      const layer = document.querySelector('.layer-popup-container');
      if (!layer) return;

      const inner = layer.querySelector('.layer-popup');
      if (!inner) return;

      const style = getComputedStyle(inner);
      const pdt = parseFloat(style.paddingTop) || 0;
      const pdb = parseFloat(style.paddingBottom) || 0;

      const footer = layer.querySelector('.popup-footer');
      const header = inner.querySelector('.popup-header');

      const bottomFixedHeight = footer ? footer.offsetHeight : 0;
      const headerHeight = header ? header.offsetHeight : 0;

      const popupBody = inner.querySelector('.popup-body');
      if (!popupBody) return;

      const maxHeight =
        window.innerWidth > 800
          ? layer.offsetHeight * 0.7 - (pdt + pdb) - bottomFixedHeight - headerHeight
          : layer.offsetHeight * 0.9 - (pdt + pdb) - bottomFixedHeight - headerHeight;

      popupBody.style.maxHeight = `${maxHeight}px`;
    },
    // 팝업 max-height 리사이즈
		setResizeEvent() {
			window.removeEventListener("resize", this.resizeHandler);

			this.resizeHandler = () => {
				this.setLayerHeight();
			};

			window.addEventListener("resize", this.resizeHandler);

			this.$nextTick(() => {
        setTimeout(() => {
          this.setLayerHeight();
        }, 0);
      });
		},
    // 가로 스크롤 터치 이벤트 설정
    setupHorizontalScroll() {
      const categoryLists = document.querySelectorAll('.category-items-list');
      categoryLists.forEach(list => {
        let isDown = false;
        let startX;
        let scrollLeft;

        list.addEventListener('mousedown', (e) => {
          isDown = true;
          list.classList.add('active');
          startX = e.pageX - list.offsetLeft;
          scrollLeft = list.scrollLeft;
        });

        list.addEventListener('mouseleave', () => {
          isDown = false;
          list.classList.remove('active');
        });

        list.addEventListener('mouseup', () => {
          isDown = false;
          list.classList.remove('active');
        });

        list.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - list.offsetLeft;
          const walk = (x - startX) * 2; // 스크롤 속도 조절
          list.scrollLeft = scrollLeft - walk;
        });

        // 모바일 터치 이벤트
        list.addEventListener('touchstart', (e) => {
          isDown = true;
          startX = e.touches[0].pageX - list.offsetLeft;
          scrollLeft = list.scrollLeft;
        });

        list.addEventListener('touchend', () => {
          isDown = false;
        });

        list.addEventListener('touchmove', (e) => {
          if (!isDown) return;
          const x = e.touches[0].pageX - list.offsetLeft;
          const walk = (x - startX) * 2;
          list.scrollLeft = scrollLeft - walk;
        });
      });
    },
    showMainCategoryScrollHint() {
      // console.log('메인 카테고리 스크롤 힌트 실행');

      const scrollContainer = document.querySelector('section.msection .category-items'); // 실제 스크롤이 일어나는 요소
      const contentList = document.querySelector('section.msection .category-items > .category-items-list'); // 너비 체크용 (선택사항)

      if (scrollContainer) {
        // 스크롤 가능 여부는 실제 스크롤 컨테이너인 scrollContainer를 기준으로 판단해야 합니다.
        // console.log('스크롤 컨테이너(.category-items) 정보:', scrollContainer.scrollWidth, scrollContainer.clientWidth);

        if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
          // console.log('스크롤 가능한 요소(.category-items) 감지');

          const originalScrollLeft = scrollContainer.scrollLeft;

          setTimeout(() => {
            scrollContainer.style.scrollBehavior = 'smooth'; // 실제 스크롤 컨테이너에 적용
            const scrollAmount = Math.min(scrollContainer.scrollWidth / 3, 70); // 필요시 스크롤 양 계산 기준도 컨테이너로
            // console.log('스크롤 시작, 스크롤 양:', scrollAmount);
            scrollContainer.scrollLeft = scrollAmount; // 실제 스크롤 컨테이너 조작

            setTimeout(() => {
              // console.log('원래 위치로 스크롤 복귀');
              scrollContainer.scrollLeft = originalScrollLeft; // 실제 스크롤 컨테이너 조작
              setTimeout(() => {
                scrollContainer.style.scrollBehavior = '';
              }, 500);
            }, 1200);
          }, 800);
        } else {
          // console.log('스크롤 가능한 요소(.category-items)가 아님');
        }
      } else {
        // console.log('스크롤 컨테이너(.category-items)를 찾을 수 없음');
      }
    },
    showMutualEventScrollHint() {
      // 상호할인 이벤트 목록 선택
      const mutualEventList = document.querySelector('.mutual-event-list');

      if (mutualEventList && this.isMobile && mutualEventList.scrollWidth > mutualEventList.clientWidth) {
        // 초기 상태 저장
        const originalScrollLeft = mutualEventList.scrollLeft;

        // 오른쪽으로 스크롤하는 애니메이션
        setTimeout(() => {
          // 부드럽게 스크롤
          mutualEventList.style.scrollBehavior = 'smooth';

          // 현재 스크롤 위치 기준 오른쪽으로 70px 또는 최대 1/3까지만 스크롤
          const scrollAmount = Math.min(mutualEventList.scrollWidth / 3, 70);
          mutualEventList.scrollLeft = scrollAmount;

          // 잠시 기다린 후 다시 원래 위치로 스크롤
          setTimeout(() => {
            mutualEventList.scrollLeft = originalScrollLeft;

            // 애니메이션 종료 후 부드러운 스크롤 비활성화
            setTimeout(() => {
              mutualEventList.style.scrollBehavior = '';
            }, 500);
          }, 1200);
        }, 600); // 메인 카테고리 애니메이션 후에 실행되도록 시간 조정
      }
    },

    // 공통 정렬 로직
    applySort() {
      // originalFilteredList는 필터링만 적용된 목록
      let listToSort = [...this.originalFilteredList];

      if (this.sortCd === "F") {
        listToSort.sort((a, b) => b.likeCount - a.likeCount);
      } else if (this.sortCd === "PD") {
        listToSort.sort((a, b) => b.price - a.price);
      } else if (this.sortCd === "PU") {
        listToSort.sort((a, b) => a.price - b.price);
      }
      // 정렬이 없는 경우 (sortCd === '') 원본(originalFilteredList) 순서 유지

      // allManprdList는 최종적으로 화면에 표시될 (필터링+정렬된) 목록
      this.allManprdList = listToSort;
      this.totalCount = this.allManprdList.length;
      this.pageNo = 1; // 정렬 후 1페이지로 이동

      if (!this.isMobile) {
        // PC: manprdFilterList도 업데이트 (페이지네이션용)
        this.manprdFilterList = [...this.allManprdList];
        this.getManprdList(1); // PC 페이지네이션 업데이트
      }
      // 모바일: currentPageItems computed 속성이 this.allManprdList 변경을 감지하고
      // 자동으로 업데이트되어 Swiper에 반영됨 (별도 Swiper 업데이트 호출 불필요)
    },

    // 전체 상품 데이터 로드 (서버에서)
    async fetchAllManprd() {
      // 데이터 초기화
      this.manprdAllList = []; // 서버 원본
      this.allManprdList = []; // 필터/정렬 후 표시용
      this.originalFilteredList = []; // 필터만 적용된 목록
      this.manprdList = []; // PC 페이지네이션용
      this.manprdFilterList = []; // PC 필터/정렬용
      this.totalCount = 0;
      this.pageNo = 1;

      if (!this.campnId) {
        console.warn("CampnId not available yet for fetching products.");
        return; // 캠페인 ID 없으면 중단
      }

      try {
        // API 호출 시 필터 조건 포함 (서버 필터링 활용 시)
        // 현재는 클라이언트 필터링이므로 모든 데이터 요청
        const res = await this.$store.dispatch(
          `manprd/${ACT_GET_CAMPN_MANPRD_LIST}`,
          {
            campnId: this.campnId,
            manprdNm: "", // 서버 필터링 안 함
            ctgrDcd: "", // 서버 필터링 안 함
            subCtgrDcd: "", // 서버 필터링 안 함
            sortCd: "", // 서버 정렬 안 함
            pageNo: 1,
            pageSize: 1000, // 충분히 큰 값으로 모든 데이터 가져오기
          }
        );
        if (lengthCheck(res)) {
          const items = getCheckItems(res).map((i) => ({
            id: i.manprdId,
            image: i.manprdImgFileUrl,
            company: i.brndNm,
            title: i.manprdNm,
            price: i.manprdPrc,
            rate: i.socreAvg,
            rateCount: i.scoreCnt,
            like: i.favrYn == "Y",
            likeCount: i.likeCount,
            shareCount: i.shareCount,
            myRate: i.myScore,
            desc: i.manprdDesc,
            siteUrl: i.ntslSiteUrl,
            reviewUrl:i.reviewUrl,
            saleYn:i.saleYn,
            isEng: false,
            useCampnDurYn: i.useCampnDurYn == "Y",
            ntslStrtDt: timestampToDateFormat(i.ntslStrtDt, "yyyy-MM-dd"),
            ntslEndDt: timestampToDateFormat(i.ntslEndDt, "yyyy-MM-dd"),
            ctgrDcd: i.ctgrDcd,
            subCtgrDcd: i.subCtgrDcd,
            manprdComp: i.manprdComp,
          }));
          this.manprdAllList = items; // 서버 원본 데이터 저장

          // 초기 필터링 적용 (현재 선택된 카테고리, 검색어 기준)
          this.applyInitialFilters();
          
          this.getMostLikedProducts();
        } else {
          // 데이터 없을 때 초기화
          this.manprdAllList = [];
          this.allManprdList = [];
          this.originalFilteredList = [];
          this.totalCount = 0;
          this.manprdList = [];
          this.manprdFilterList = [];
          if (this.isMobile) {
            this.$nextTick(() => {
              if (this.swiperInstance) this.swiperInstance.update();
            });
          }
        }
      } catch (e) {
        console.error("Error fetching all products:", e);
        // 오류 시 초기화
        this.manprdAllList = [];
        this.allManprdList = [];
        this.originalFilteredList = [];
        this.totalCount = 0;
        this.manprdList = [];
        this.manprdFilterList = [];
        if (this.isMobile) {
          this.$nextTick(() => {
            if (this.swiperInstance) this.swiperInstance.update();
          });
        }
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: "상품 데이터를 로드하는 중 오류가 발생했습니다.",
          rightNow: true,
        });
      }
    },

    // 초기 필터링 적용 (데이터 로드 후 호출)
    applyInitialFilters() {
      let baseList = [...this.manprdAllList]; // 서버 원본 사용

      // 검색어 필터
      if (this.searchName) {
        // 현재 필터링된 목록을 가지고 이동
          const keyword = this.searchName.toLowerCase();
          const filteredList = this.manprdAllList.filter((m) =>
            m.title.toLowerCase().includes(keyword) || 
            (m.company && m.company.toLowerCase().includes(keyword))
          );
          sessionStorage.setItem('manprdAllList', JSON.stringify(this.manprdAllList));
          sessionStorage.setItem('search_results', JSON.stringify(filteredList));
          
          this.$router.push({
            name: 'SearchResult',
            query: { q: this.searchName }
          });
          return; 
      }
      // 메인 카테고리 필터
      if (this.ctgrDcd) {
        baseList = baseList.filter((m) => m.ctgrDcd === this.ctgrDcd);
      }
      // 서브 카테고리 필터
      if (this.subCtgrDcd) {
        baseList = baseList.filter((m) => m.subCtgrDcd === this.subCtgrDcd);
      }

      // 검색 결과가 없으면 다른 탬플릿 보여주기
      if (baseList.length === 0) {
        this.searchFlag = false;
      } else {
        this.searchFlag = true;
      }

      this.originalFilteredList = [...baseList]; // 필터링 결과 저장
      this.totalCount = this.originalFilteredList.length;

      this.applySort(); // 정렬 적용
    },

    // PC 화면용 상품 목록 업데이트 (페이지네이션)
    getManprdList(pageNo) {
      this.pageNo = pageNo || 1;

      // 모바일인 경우 currentPageItems 업데이트를 위한 처리
      if (this.isMobile) {
        this.$nextTick(() => {
          // Swiper 슬라이드를 첫 번째로 이동
          if (this.thisSwiper && !this.thisSwiper.destroyed) {
            this.thisSwiper.slideTo(0, 0);
          }
        });
        return;
      }
      // this.pageNo = pageNo || 1;
      this.manprdList = []; // PC 목록 초기화
      const start = (this.pageNo - 1) * this.pageSize;
      const end = start + this.pageSize;
      // manprdFilterList는 PC용 필터/정렬된 목록
      this.manprdList = this.manprdFilterList.slice(start, end);
    },

    // 메인 카테고리/검색 필터 적용
    async applyFiltersAndFetchAll(dcd) {
      // dcd가 undefined이면 검색 버튼 클릭으로 간주
      if (dcd !== undefined) {
        this.ctgrDcd = dcd;
      }
      this.subCtgrDcd = ""; // 메인 카테고리 변경 시 서브 카테고리 초기화
      this.pageNo = 1; // 필터 변경 시 1페이지로

      // 서브 카테고리 목록 업데이트
      if (this.ctgrDcd) {
        const filteredSubCategories = this.subCodeList.filter(
          (sub) => sub.ctgrDcd == this.ctgrDcd && sub.subCtgrDcd !== ""
        );
        this.selectCodeList = [
          { subCtgrDcd: "", subCtgrNm: "전체" },
          ...filteredSubCategories,
        ];
        // 서브 카테고리 목록이 업데이트된 후 스크롤 위치를 왼쪽으로 초기화
        this.$nextTick(() => {
          const subCategoryList = document.querySelector('.category-items-list.type02');
          if (subCategoryList) {
            subCategoryList.scrollLeft = 0;
          }
        });
      } else {
        this.selectCodeList = []; // '전체' 선택 시 서브 카테고리 숨김
      }

      // 서버에서 다시 로드할 필요 없음 (이미 manprdAllList에 전체 데이터 있음)
      // 클라이언트 측 필터링 적용
      this.applyInitialFilters();
    },

    searchHashtag(tagName) {
      this.searchName = tagName;
      this.applyFiltersAndFetchAll();
    },

    // 서브 카테고리 필터 적용
    applySubFiltersAndFetchAll(dcd) {
      this.subCtgrDcd = dcd;
      this.pageNo = 1; // 필터 변경 시 1페이지로

      // 클라이언트 측 필터링 적용
      this.applyInitialFilters();
    },

    // PC 정렬 순서 설정
    setSortOrder(newSortCd) {
      if (this.isMobile) return; // PC에서만 실행
      let targetSortCd = newSortCd;
      // 토글 로직
      if (newSortCd === "F" && this.sortCd === "F") {
        targetSortCd = "";
      } else if (newSortCd === this.sortCd) {
        // 같은 버튼을 다시 누르면 정렬 해제
        targetSortCd = "";
      }
      this.sortCd = targetSortCd;
      this.applySort(); // 정렬 적용
    },

    // 모바일 정렬 순서 설정
    setSortOrderAndFetchAll(newSortCd) {
      let targetSortCd = newSortCd;
      // 토글 로직
      if (newSortCd === this.sortCd) {
        targetSortCd = "";
      } else if (newSortCd === "F" && this.sortCd === "F") {
        targetSortCd = "";
      }
      this.sortCd = targetSortCd;
      this.applySort(); // 정렬 적용 (내부에서 Swiper 업데이트 트리거됨)
    },

    // 모바일 이전 페이지 이동 (복원)
    goToPrevPage() {
      if (this.pageNo > 1) {
        if (this.pageNo > 1) {
          this.getManprdList(this.pageNo - 1);
        }
        // Swiper 슬라이드를 첫 번째로 이동
        // this.$nextTick(() => {
        //   // thisSwiper (data 속성) 사용 및 존재 확인
        //   if (this.thisSwiper && !this.thisSwiper.destroyed) {
        //     this.thisSwiper.slideTo(0, 300); // 0번 인덱스(첫 슬라이드)로 300ms 동안 이동
        //   }
        // });
      }
    },

    // 모바일 다음 페이지 이동 (수정)
    goToNextPage() {
      if (this.pageNo < this.totalPages) {
        if (this.pageNo < this.totalPages) {
          this.getManprdList(this.pageNo + 1);
        }
        // Swiper 슬라이드를 첫 번째로 이동
        // this.$nextTick(() => {
        //   // thisSwiper (data 속성) 사용 및 존재 확인
        //   if (this.thisSwiper && !this.thisSwiper.destroyed) {
        //     this.thisSwiper.slideTo(0, 300); // 0번 인덱스(첫 슬라이드)로 300ms 동안 이동
        //   }
        // });
      }
    },
    handleMutualEventMouseDown(e) {
      if (this.isMobile) return;

      const el = this.$refs.mutualEventContainerPC;
      if (!el) return;

      this.isDraggingMutualEvent = true;
      this.hasDraggedMutualEvent = false;
      el.style.cursor = 'grabbing';
      el.style.userSelect = 'none';

      // getBoundingClientRect()를 사용하여 화면 기준으로 x 좌표를 가져옵니다.
      const rect = el.getBoundingClientRect();
      this.startXMutualEvent = e.clientX - rect.left; // e.pageX 대신 e.clientX, el.offsetLeft 대신 rect.left
      this.scrollLeftMutualEvent = el.scrollLeft;

      // console.log('Mousedown: startX=', this.startXMutualEvent, 'scrollLeft=', this.scrollLeftMutualEvent);

      window.addEventListener('mousemove', this.handleMutualEventGlobalMouseMove);
      window.addEventListener('mouseup', this.handleMutualEventGlobalMouseUp);
    },

    handleMutualEventClick(event,beforeEvent,link) {
      // 드래그 이벤트 처리 (PC 전용)
      if (!this.isMobile && this.hasDraggedMutualEvent) {

        event.preventDefault();
        this.hasDraggedMutualEvent = false; // 플래그 초기화
        return;
      }

      // 이벤트 기간 확인
      const eventTime = beforeEvent
      const now = new Date();

      if (now < eventTime || link == '') {
        event.preventDefault(); // 링크 이동 방지
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: "4/11(토)부터 참여할 수 있습니다.",
          rightNow: true,
        });
      }
    },
    handleMutualEventGlobalMouseMove(e) { // 이름 변경 및 전역 핸들러로 사용
      if (!this.isDraggingMutualEvent) return;

      e.preventDefault(); // 항상 preventDefault 호출하여 기본 드래그 동작 방지

      const el = this.$refs.mutualEventContainerPC;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const currentX = e.clientX - rect.left;
      const walk = currentX - this.startXMutualEvent; // 직접적인 이동 거리 계산

      // scrollLeft 값 업데이트
      el.scrollLeft = this.scrollLeftMutualEvent - walk * 1.5; // 스크롤 감도 (1.5) 조절 가능

      // console.log('MouseMove: currentX=', currentX, 'walk=', walk, 'newScrollLeft=', el.scrollLeft);

      // 드래그 발생 여부 판단 (클릭과 구분)
      // 처음 mousedown 시점의 scrollLeft와 현재 scrollLeft가 다르면 드래그로 간주
      // 또는, 시작 x좌표와 현재 x좌표의 차이가 일정 이상이면 드래그로 간주
      if (!this.hasDraggedMutualEvent) {
        // e.clientX와 mousedown 시점의 e.clientX (별도 저장 필요)를 비교하거나,
        // 간단하게 mousemove가 한 번이라도 호출되면 드래그로 간주할 수도 있습니다.
        // 여기서는 조금 더 명확하게 하기 위해, 초기 위치에서 얼마나 벗어났는지 체크합니다.
        const initialPageX = this.startXMutualEvent + rect.left; // mousedown 시점의 페이지 X 좌표 복원
        if (Math.abs(e.clientX - initialPageX) > 5) { // 임계값 5px
          this.hasDraggedMutualEvent = true;
          //  console.log('Drag detected');
        }
      }
    },
    handleMutualEventGlobalMouseUp(e) { // 이름 변경 및 전역 핸들러로 사용
      if (!this.isDraggingMutualEvent) return;

      const el = this.$refs.mutualEventContainerPC;
      if (el) {
        el.style.cursor = 'grab';
        el.style.userSelect = '';
      }

      this.isDraggingMutualEvent = false;
      // hasDraggedMutualEvent는 handleMutualEventItemClick에서 처리하므로 여기서는 건드리지 않음

      // console.log('Mouseup: hasDragged=', this.hasDraggedMutualEvent);

      window.removeEventListener('mousemove', this.handleMutualEventGlobalMouseMove);
      window.removeEventListener('mouseup', this.handleMutualEventGlobalMouseUp);
    },

    // 소상공인 온라인 기획전 목록
    async getMutualDiscountEvent() {
      try {
        this.mutualDisEventListPC = [
          {name: "우체국쇼핑", link: "https://mall.epost.go.kr/fo/display/plnbefDspyNewView.do?plnbefId=10027047", img: "02_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "오아시스", link: "https://www.oasis.co.kr/event/2026/catSosang_0411", img: "03_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "H몰", link: "https://www.hmall.com/md/dpa/searchSpexSectItem?sectId=2811083", img: "04_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "지그재그", link: "https://zigzag.kr/events/f81fbb2e-a59f-437a-9db0-87c1317d40bb", img: "05_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "지마켓", link: "http://rpp.gmarket.co.kr/?exhib=259773", img: "06_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "그립", link: "https://www.grip.show/event/with_on-market", img: "13_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "SK스토아", link: "https://skstoa.com/plan/event/detail/2026042847", img: "07_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "롯데온", link: "https://www.lotteon.com/m/display/planV2/planDetail/120320 ", img: "08_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "11번가", link: "https://plan.11st.co.kr/plan/front/exhibitions/2211141/detail", img: "09_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "NS홈쇼핑", link: "https://m.nsmall.com/store/atypical/1009576264", img: "10_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "현대이지웰", link: "https://www.onnuri-sijang.com/onnuri/plan/planDetail?planCd=2019", img: "01_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          // {name: "화해", link: "https://www.oasis.co.kr/event/2025/catSosang_1029", img: "11_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
          {name: "SSG", link: "https://ssg.com/plan/planShop.ssg?dispCmptId=6000465146", img: "12_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "마켓컬리", link: "https://www.kurly.com/collections/2604donghaengsale", img: "14_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "온라인전통시장관", link: "https://www.onnuri.gift/market?pageNo=1", img: "16_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "공영홈쇼핑", link: "https://www.gongyoungshop.kr/exhibition/ebtDetail.do?ebtNo=4315", img: "17_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "소상공인<br>연합회", link: "https://kfmefestival26.pages.dev/", img: "18_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          // {name: "카카오톡딜", link: "https://www.oasis.co.kr/event/2025/catSosang_1029", img: "15_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },

        ];
        this.mutualDisEventListMobile = [
          {name: "우체국쇼핑", link: "https://mall.epost.go.kr/fo/display/plnbefDspyNewView.do?plnbefId=10027047", img: "02_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "오아시스", link: "https://www.oasis.co.kr/event/2026/catSosang_0411", img: "03_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "H몰", link: "https://www.hmall.com/md/dpa/searchSpexSectItem?sectId=2811083", img: "04_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "지그재그", link: "https://zigzag.kr/events/f81fbb2e-a59f-437a-9db0-87c1317d40bb", img: "05_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "지마켓", link: "http://rpp.gmarket.co.kr/?exhib=259773", img: "06_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "그립", link: "https://www.grip.show/event/with_on-market", img: "13_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "SK스토아", link: "https://skstoa.com/plan/event/detail/2026042847", img: "07_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "롯데온", link: "https://www.lotteon.com/m/display/planV2/planDetail/120320 ", img: "08_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "11번가", link: "https://plan.11st.co.kr/plan/front/exhibitions/2211141/detail", img: "09_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "NS홈쇼핑", link: "https://m.nsmall.com/store/atypical/1009576264", img: "10_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "현대이지웰", link: "https://www.onnuri-sijang.com/onnuri/plan/planDetail?planCd=2019", img: "01_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          // {name: "화해", link: "https://www.oasis.co.kr/event/2025/catSosang_1029", img: "11_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
          {name: "SSG", link: "https://ssg.com/plan/planShop.ssg?dispCmptId=6000465146", img: "12_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "마켓컬리", link: "https://www.kurly.com/collections/2604donghaengsale", img: "14_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "온누리 전통시장관", link: "https://www.onnuri.gift/market?pageNo=1", img: "16_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "공영홈쇼핑", link: "https://www.gongyoungshop.kr/exhibition/ebtDetail.do?ebtNo=4315", img: "17_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          {name: "소상공인<br>연합회", link: "https://kfmefestival26.pages.dev/", img: "18_new.png", beforeEvent: new Date('2026-04-11T09:00:00') },
          // {name: "카카오톡딜", link: "https://www.oasis.co.kr/event/2025/catSosang_1029", img: "15_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
        ];
      } catch (e) {
        console.error("Error fetching mutual discount event:", e);
      }
    },
    // 메인 카테고리 목록 가져오기
    async getCtgrList() {
      try {
        const res = await this.$store.dispatch(
          `common/${ACT_GET_COMMON_CODE_LIST}`,
          { dcd: "1501", masterYn: "N" }
        );
        if (lengthCheck(res)) {
          const items = getItems(res).map((i) => {
            let imgName = "default_icon.png",
              title = i.dcdVal;
            switch (i.dcd) {
              case "1501001":
                imgName = "list_item02.png";
                // title = "뷰티";
                break;
              case "1501002":
                imgName = "list_item03.png";
                // title = "생활";
                break;
              case "1501003":
                imgName = "list_item04.png";
                // title = "식품";
                break;
              case "1501004":
                imgName = "list_item05.png";
                // title = "전자기기";
                break;
              case "1501005":
                imgName = "list_item06.png";
                // title = "가구·조명";
                break;
              case "1501006":
                imgName = "list_item07.png";
                // title = "주방";
                break;
              case "1501007":
                imgName = "list_item08.png";
                // title = "패션·잡화";
                break;
              case "1501008":
                imgName = "list_item09.png";
                // title = "가전/기타";
                break;
            }
            return { ...i, img: imgName, dcdVal: title };
          });
          this.ctgrItems = [
            { dcd: "", dcdVal: "전체", img: "list_item01.png" },
            ...items,
          ];
        } else {
          this.ctgrItems = [
            { dcd: "", dcdVal: "전체", img: "list_item01.png" },
          ];
        }
      } catch (e) {
        console.error("Error fetching categories:", e);
        this.ctgrItems = [{ dcd: "", dcdVal: "전체", img: "list_item01.png" }];
      }
    },

    // 서브 카테고리 목록 가져오기
    async getSubCtgrList() {
      try {
        const res = await this.$store.dispatch(
          `manprd/${ACT_GET_SUB_CTGR_CODE_LIST}`
        );
        if (lengthCheck(res)) {
          const subCategories = getItems(res);
          this.subCodeList = subCategories; // 전체 서브 카테고리 저장
          // 초기 selectCodeList 설정 (ctgrDcd가 있다면)
          if (this.ctgrDcd) {
            const filteredSubCategories = this.subCodeList.filter(
              (sub) => sub.ctgrDcd == this.ctgrDcd && sub.subCtgrDcd !== ""
            );
            this.selectCodeList = [
              { subCtgrDcd: "", subCtgrNm: "전체" },
              ...filteredSubCategories,
            ];
          } else {
            this.selectCodeList = []; // 초기에는 비워둠
          }
        } else {
          this.subCodeList = [];
          this.selectCodeList = [];
        }
      } catch (e) {
        console.error("Error fetching sub-categories:", e);
        this.subCodeList = [];
        this.selectCodeList = [];
      }
    },

    // 이벤트 기간 정보 가져오기
    async getEvntMng() {
      if (!this.campnId) {
        console.warn("CampnId not available yet for fetching event info.");
        this.evntStrtDt = this.campn?.strtDt || "";
        this.evntEndDt = this.campn?.endDt || "";
        return;
      }
      try {
        const res = await this.$store.dispatch(
          `event/${ACT_GET_DHFESTA_EVENT_MNG}`,
          { campnId: this.campnId, evntTyp: "20" }
        );
        if (lengthCheck(res)) {
          const item = getItem(res);
          this.evntStrtDt =
            timestampToDateFormat(Number(item.evntStrtDt), "yyyy-MM-dd") +
            " 00:00";
          this.evntEndDt =
            timestampToDateFormat(Number(item.evntEndDt), "yyyy-MM-dd") +
            " 00:00";
        } else {
          this.evntStrtDt = this.campn?.strtDt || "";
          this.evntEndDt = this.campn?.endDt || "";
        }
      } catch (e) {
        console.error("Error fetching event:", e);
        this.evntStrtDt = this.campn?.strtDt || "";
        this.evntEndDt = this.campn?.endDt || "";
      }
    },

    // PC 찜하기 클릭 처리
    handleClickLike(idx, type) {
      if (!this.isMobile) {
        // PC 목록(manprdList)에서 아이템 찾기
        const item = this.manprdList.find((i) => i.id === idx);
        if (item) {
          this.setFavr(item);
        }
      }
      // 모바일 찜하기는 Swiper 슬라이드 내부 버튼에서 직접 setFavr 호출
    },

    // 모달 열기
    handleClickModal(idx, type) {
      this.modalId = idx;
      this.visibleModal = true;
    },

    // 모달 내부 이벤트 처리 (찜하기, 별점 등)
    handleClickModalEvnt(type, score) {
      // 모달에서 찜 상태 변경 시, 전체 목록(manprdAllList) 업데이트 필요
      const modalItemInAllList = this.manprdAllList.find(
        (i) => i.id === this.modalId
      );
      if (modalItemInAllList) {
        // 서버 응답 기다리지 않고 UI 즉시 업데이트 (Optimistic Update)
        if (type === "F") {
          // 찜하기 이벤트
          modalItemInAllList.like = !modalItemInAllList.like;
          modalItemInAllList.likeCount += modalItemInAllList.like
            ? 1
            : modalItemInAllList.likeCount > 0
              ? -1
              : 0;
        }
        // 필요하다면 별점(myRate) 업데이트 로직 추가
        // modalItemInAllList.myRate = score;

        // 필터링 및 정렬 다시 적용하여 화면 갱신
        this.applyInitialFilters();
      }

      // 실제 서버 업데이트는 ProductsModal 내부 또는 여기서 별도 처리 필요
      // 예: if (type === 'F') { this.setFavr(this.modalItem); }
      // 예: else if (type === 'S') { this.setStar(this.modalItem, score); }
    },

    // 로그인 체크
    chkLogin(title) {
      if (!this.isAuth) {
        const param = {
          title: title,
          html: true,
          showCancelButton: true,
          yesButtonText: "로그인",
          cancelButtonText: "취소",
          yesfunc: () => {
            this.$store.commit(
              `common/${MUT_SET_RETURN_ROUTE}`,
              this.$route.fullPath
            );
            this.$router.push({ name: "Login" });
          },
          nofunc: () => {},
        };
        this.$store.commit(`common/${MUT_SHOW_CONFIRM}`, param);
        return false;
      }
      return true;
    },

    // 캠페인 기간 체크
    chkCampnDuration() {
      if (!this.campn?.strtDt || !this.campn?.endDt) {
        console.warn("Campaign dates not available for duration check.");
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: `이벤트 기간 정보가 유효하지 않습니다.`,
          html: true,
          rightNow: true,
        });
        return false;
      }
      const nowDt = dateToDateFormat(new Date(), "yyyy-MM-dd") + " 00:00";
      if (
        countDDay(this.campn.strtDt, nowDt) < 0 ||
        countDDay(nowDt, this.campn.endDt) < 0
      ) {
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: `이벤트 기간이 아닙니다.<br>(기간: ${this.campn.strtDt.substring(
            0,
            10
          )} ~ ${this.campn.endDt.substring(0, 10)})`,
          html: true,
          rightNow: true,
        });
        return false;
      }
      return true;
    },

    // 찜하기 처리 (공통)
    setFavr(item) {
      if (!this.chkCampnDuration()) return false;
      if (
        !this.chkLogin(
          "로그인 상태에서 찜할 수 있습니다.<br>로그인하시겠습니까?"
        )
      )
        return false;

      // 원본 데이터(manprdAllList)에서 해당 아이템 찾기
      const itemInAllList = this.manprdAllList.find((i) => i.id === item.id);
      if (!itemInAllList) return; // 아이템 없으면 중단

      const originalLike = itemInAllList.like;
      const originalLikeCount = itemInAllList.likeCount;

      // Optimistic Update: UI 즉시 변경
      itemInAllList.like = !itemInAllList.like;
      itemInAllList.likeCount += itemInAllList.like
        ? 1
        : originalLikeCount > 0
          ? -1
          : 0;

      // PC 목록(manprdList)에도 반영 (PC 화면용)
      if (!this.isMobile) {
        const itemInPcList = this.manprdList.find((i) => i.id === item.id);
        if (itemInPcList) {
          itemInPcList.like = itemInAllList.like;
          itemInPcList.likeCount = itemInAllList.likeCount;
        }
      }

      // Swiper 업데이트 (모바일 화면용)
      const updateSwiper = () => {
        if (this.isMobile) {
          this.$nextTick(() => {
            // thisSwiper 사용
            if (this.thisSwiper) this.thisSwiper.update();
          });
        }
      };
      updateSwiper(); // UI 변경 후 즉시 Swiper 업데이트

      // 서버 API 호출
      this.$store
        .dispatch(`manprd/${ACT_UPDATE_CAMPN_MANPRD_FAVR}`, {
          manprdId: item.id,
          params: {
            manprdId: item.id,
            score: 0,
            useYn: itemInAllList.like ? "Y" : "N",
          },
        })
        .then((res) => {
          // API 성공/실패 처리
          this.getFavrAlter(
            itemInAllList,
            res,
            originalLike,
            originalLikeCount
          );
        })
        .catch((e) => {
          console.error("Error updating favorite:", e);
          // API 실패 시 롤백
          itemInAllList.like = originalLike;
          itemInAllList.likeCount = originalLikeCount;
          if (!this.isMobile) {
            // PC 목록 롤백
            const itemInPcList = this.manprdList.find((i) => i.id === item.id);
            if (itemInPcList) {
              itemInPcList.like = originalLike;
              itemInPcList.likeCount = originalLikeCount;
            }
          }
          updateSwiper(); // 롤백 후 Swiper 업데이트
          this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
            title: "찜하기 처리 중 오류가 발생했습니다.",
            rightNow: true,
          });
        });
    },

    // 찜하기 결과 처리 (API 응답 후)
    getFavrAlter(item, res, originalLike, originalLikeCount) {
      const updateSwiper = () => {
        if (this.isMobile) {
          this.$nextTick(() => {
            // thisSwiper 사용
            if (this.thisSwiper) this.thisSwiper.update();
          });
        }
      };

      if (isSuccess(res)) {
        // API 성공 시 알림
        let text = item.like
          ? "찜 목록에 추가되었습니다."
          : "찜 목록에서 삭제되었습니다.";
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: text,
          rightNow: true,
        });
        // UI는 이미 Optimistic Update로 변경됨
      } else {
        // API 실패 시 롤백 (setFavr의 catch 블록에서 이미 처리됨)
        // 실패 알림
        let text = !originalLike
          ? "찜하기 등록에 실패했습니다."
          : "찜하기 해제에 실패했습니다.";
        if (res?.result?.message) text = res.result.message;
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: text,
          rightNow: true,
        });
        // 롤백 후 Swiper 업데이트 (setFavr의 catch 블록에서 이미 처리됨)
        // updateSwiper();
      }
    },
    // Hot5 좋아요 클릭 처리
    handleClickLikeHot5(item) {
      if (!this.chkCampnDuration()) return false;
      if (!this.chkLogin("로그인 상태에서 찜할 수 있습니다.<br>로그인하시겠습니까?")) return false;

      // this.setFavr(item); // 기존 setFavr 재활용
       // 원본 데이터(manprdAllList)에서 해당 아이템 찾기
      const itemInAllList = this.manprdAllList.find((i) => i.id === item.id);
      if (!itemInAllList) return; // 아이템 없으면 중단

      const originalLike = itemInAllList.like;
      const originalLikeCount = itemInAllList.likeCount;

      // Optimistic Update: UI 즉시 변경
      itemInAllList.like = !itemInAllList.like;
      itemInAllList.likeCount += itemInAllList.like
        ? 1
        : originalLikeCount > 0
          ? -1
          : 0;
      
      // Hot5 목록(mostLikedProducts)에도 반영
      const itemInHot5 = this.mostLikedProducts.find((i) => i.id === item.id);
      if(itemInHot5) {
          itemInHot5.like = itemInAllList.like;
          itemInHot5.likeCount = itemInAllList.likeCount;
      }

      // PC 목록(manprdList)에도 반영 (PC 화면용)
      if (!this.isMobile) {
        const itemInPcList = this.manprdList.find((i) => i.id === item.id);
        if (itemInPcList) {
          itemInPcList.like = itemInAllList.like;
          itemInPcList.likeCount = itemInAllList.likeCount;
        }
      }

       // Swiper 업데이트 (모바일 화면용)
      const updateSwiper = () => {
        if (this.isMobile) {
          this.$nextTick(() => {
            // thisSwiper 사용
            if (this.thisSwiper) this.thisSwiper.update();
          });
        }
      };
      updateSwiper(); // UI 변경 후 즉시 Swiper 업데이트


      // 서버 API 호출
      this.$store
        .dispatch(`manprd/${ACT_UPDATE_CAMPN_MANPRD_FAVR}`, {
          manprdId: item.id,
          params: {
            manprdId: item.id,
            score: 0,
            useYn: itemInAllList.like ? "Y" : "N",
          },
        })
        .then((res) => {
          // API 성공/실패 처리
          this.getFavrAlter(
            itemInAllList,
            res,
            originalLike,
            originalLikeCount
          );
        })
        .catch((e) => {
          console.error("Error updating favorite:", e);
          // API 실패 시 롤백
          itemInAllList.like = originalLike;
          itemInAllList.likeCount = originalLikeCount;
           if(itemInHot5) {
              itemInHot5.like = originalLike;
              itemInHot5.likeCount = originalLikeCount;
          }
          if (!this.isMobile) {
            // PC 목록 롤백
            const itemInPcList = this.manprdList.find((i) => i.id === item.id);
            if (itemInPcList) {
              itemInPcList.like = originalLike;
              itemInPcList.likeCount = originalLikeCount;
            }
          }
          updateSwiper(); // 롤백 후 Swiper 업데이트
          this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
            title: "찜하기 처리 중 오류가 발생했습니다.",
            rightNow: true,
          });
        });
    },

    // Hot5 좋아요 클릭 처리 (단순 증가, ProductsModal likeButton과 동일)
    increaseLikeCountHot5(item) {
        this.$store
        .dispatch(`manprd/${ACT_INCREASE_MANPRD_LIKE_COUNT}`, {
          manprdId: item.id,
        })
        .then((res) => {
          if(isSuccess(res)) {
             this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
              title: "좋아요를 눌렀습니다.",
              rightNow: true,
            });
            
            // 카운트 증가 반영
             // 원본 데이터(manprdAllList)에서 해당 아이템 찾기
             const itemInAllList = this.manprdAllList.find((i) => i.id === item.id);
             if (itemInAllList) {
                 itemInAllList.likeCount += 1;
             }

            // Hot5 목록(mostLikedProducts)에도 반영
            const itemInHot5 = this.mostLikedProducts.find((i) => i.id === item.id);
            if(itemInHot5) {
                // itemInAllList가 없으면 itemInHot5에서 직접 증가, 있으면 동기화
                 if (itemInAllList) {
                    itemInHot5.likeCount = itemInAllList.likeCount;
                 } else {
                     itemInHot5.likeCount += 1;
                 }
            }

            // PC 목록(manprdList)에도 반영
            if (!this.isMobile) {
                const itemInPcList = this.manprdList.find((i) => i.id === item.id);
                if (itemInPcList) {
                    if (itemInAllList) {
                        itemInPcList.likeCount = itemInAllList.likeCount;
                    } else {
                        itemInPcList.likeCount += 1;
                    }
                }
            }
          } else {
             this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
                title: "처리 중 오류가 발생했습니다.",
                rightNow: true,
             });
          }
        })
        .catch((e) => {
          console.error("Error updating like count:", e);
           this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
              title: "처리 중 오류가 발생했습니다.",
              rightNow: true,
           });
        });
    },
    // Hot5 공유하기 클릭 처리
    handleClickShareHot5(item) {
      const url = item.siteUrl; // 혹은 공유할 특정 URL
      if (!url) {
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: "복사할 링크가 없습니다.",
          rightNow: true,
        });
        return;
      }

      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
            title: "링크가 복사되었습니다.",
            rightNow: true,
          });
          // 공유하기 카운트 증가
          this.$store.dispatch(`manprd/${ACT_INCREASE_MANPRD_SHARE_COUNT}`, {
            manprdId: item.id,
          });
        })
        .catch((err) => {
          console.error("Link copy failed", err);
          this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
             title: "링크 복사에 실패했습니다.",
             rightNow: true,
          });
        });
    },

    getMostLikedProducts() {
      if (this.manprdAllList && this.manprdAllList.length > 0) {
        // 좋아요 수(likeCount) 내림차순 정렬 후 상위 5개 추출
        this.mostLikedProducts = [...this.manprdAllList]
          .sort((a, b) => b.likeCount - a.likeCount)
          .slice(0, 5);
      } else {
        this.mostLikedProducts = [];
      }
    },
  },
  metaInfo() {
    return {
      title: "2026 동행축제",
      link: [
        {
          rel: "icon",
          type: "image/png",
          href: "/DH-favicon-v3.png",
        },
        {
          rel: "shortcut icon",
          href: "/DH-favicon-v3.png",
        },
        {
          rel: "canonical",
          href: "https://www.k-shoppingfestwk rmfja a.org/ko/",
        },
        {
          rel: "alternate",
          hreflang: "ko",
          href: "https://www.k-shoppingfesta.org/ko/",
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: "https://www.k-shoppingfesta.org/ko/",
        },
      ],
    };
  }
};
$(function(){
  // 동행축제 Hot5 상품 좋아요 버튼
  $(".btn-like").on("click", function(){
    $(this).toggleClass("on");
  });

});
</script>
